export enum PublicInfoPlace {
    viewer = 'viewer',
    folder = 'folder',
    album = 'album',
    file = 'file',
    context = 'context_menu',
}

export interface PublicInfoModalPorps {
    id: string;
    qaId?: string;
    onClose?: () => void;
    place: PublicInfoPlace;
}
